import { Theme } from '@mui/material';

const SLATE_50 = '#f8fafc';
const SLATE_100 = '#f1f5f9';
const SLATE_200 = '#e2e8f0';
const SLATE_400 = '#94a3b8';
const SLATE_700 = '#334155';
const SLATE_900 = '#0f172a';

export const HaleLoginFormStyles = (theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: 700,
    letterSpacing: '0.05em',
    lineHeight: 1.2,
    color: SLATE_700,
    textTransform: 'uppercase',
    fontFamily: 'Inter, sans-serif',
  },
  formContainer: {
    display: 'flex',
    width: '100%',
    borderRadius: '12px',
    border: `2px solid ${SLATE_200}`,
    backgroundColor: SLATE_50,
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease',
  },
  flagCodeContainer: {
    minWidth: 'min(7.5rem, 100%)',
    backgroundColor: SLATE_100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: SLATE_900,
    gap: theme.custom.gap.xSmall,
    padding: '0 1rem',
    border: 'none',
    borderRight: `2px solid ${SLATE_200}`,
    height: '3.5rem',
    borderRadius: '12px 0 0 12px',
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: SLATE_200,
    },
  },
  flagCode: {
    display: 'flex',
    gap: theme.custom.gap.xSmall,
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: 700,
    color: SLATE_900,
  },
  flag: {
    width: '1.25rem',
    height: '0.875rem',
  },
  countryDropdown: {
    top: 'calc(100% + 0.5rem)',
    left: 0,
    zIndex: 20,
    maxHeight: '16rem',
    outline: 'none',
    borderRadius: '12px',
    marginTop: '0.5rem',
    padding: '0.375rem 0',
    backgroundColor: '#ffffff',
    border: `2px solid ${SLATE_200}`,
    boxShadow:
      '0 12px 32px rgba(15, 23, 42, 0.12), 0 4px 12px rgba(15, 23, 42, 0.06)',
  },
  inputStyle: {
    flex: 1,
    width: '100%',
    backgroundColor: 'transparent',
    padding: '0 1rem',
    height: '3.5rem',
    border: 'none',
    borderRadius: '0 12px 12px 0',
    color: SLATE_900,
    fontSize: '1.125rem',
    fontWeight: 600,
    outline: 'none',
    boxShadow: 'none',
    fontFamily: 'Inter, sans-serif',
    '::placeholder': {
      color: SLATE_400,
    },
  },
  error: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.custom.gap.xSmall,
    color: theme.palette.quinary?.red_400,
    fontSize: theme.typography.textSize.small,
    fontWeight: theme.typography.fontWeight.medium,
    lineHeight: theme.typography.lineHeight['1_125'],
  },
});
